import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, NavParams, ModalController } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { Item, Tracking, Master, Reviews , User, Assignment } from '@providers/asset/index';
import { DetailItemPage, FormItemPage, PicPage, DetailImagePage, 
         FinishOpnamePage, LocationPage, ClassificationPage, ConditionPage, 
         FormReviewPage, DetailItemERPPage, ProjectPage } from '../';

@Component({
  selector: 'page-item',
  templateUrl: 'page.html'
})
export class ItemPage {

  List     :any= [];
  location :any= {};
  list_path:any= [];
  tracking     = 0;
  review       = 0;
  url_image    = '';
  keyword      = '';
  currentPage  = 1;
  pageSize     = 50;
  total_rows   = 0;
  total_page   = 0;
  params:any = {
    asset_classification_code: '',
    asset_condition_id       : '',
    asset_location_id        : '',
    asset_location_path_id   : '',
    project_code             : ''
  };
  selectedClassification:any         = [];
  selectedCondition      :any        = [];
                         panelSearch = false;
  akses                 :any         = {};
  data_erp               : boolean   = false;
  data_app               : boolean   = false;
  data_valid             : boolean   = false;
  data_assignment_all    : boolean   = false;
  data_tracking_all      : boolean   = false;

  assign                = 0;
  assign_type           = '';
  assignment_id         = 0;
  assign_location_name  = '';
  assign_classification = false;
  project_code          = '';
  project_title         = '';

  item_tracking = '';
  
  constructor(
    public navCtrl        : NavController,
    public itemApi        : Item,
    public trackingApi    : Tracking,
    public masterApi      : Master,
    public userApi        : User,
    public reviewApi      : Reviews,
    public assignmentApi  : Assignment,
    public toastCtrl      : ToastController,
    public loadingCtrl    : LoadingController,
    public barcodeScanner : BarcodeScanner,
    public modalCtrl      : ModalController,
    public navParams      : NavParams
  ) {
    this.akses = this.userApi.akses;
    if(navParams.get('location')!=undefined){
      this.location = navParams.get('location');
      this.getPath(this.location.location_path_id);
      this.tracking = this.trackingApi.active;
      this.review = this.trackingApi.review;
    }
    if(navParams.get('tracking')!=undefined){
      this.tracking = navParams.get('tracking');
      console.log("tracking => ",this.tracking);
    }
    this.url_image = itemApi.base_url+'/client/uploads/';
    console.log("akses =>",this.akses);

    if(this.navParams.get('assign')==1){
      this.assign = 1;
      this.assign_type = this.navParams.get('assign_type');
      this.assignment_id = this.navParams.get('assignment_id');
      this.params.asset_location_id = this.navParams.get('asset_location_id');
      this.params.asset_classification_code = this.navParams.get('classification_code');
      if(this.params.asset_classification_code!=undefined){
        this.assign_classification = true;
      }
      this.getPath(this.navParams.get('location_path_id'));
      this.project_code = this.navParams.get('project_code');
      this.project_title = this.navParams.get('project_title');
    }

    if(navParams.get('item_tracking') !=undefined){
      this.item_tracking = navParams.get('item_tracking');
    }

    if(this.akses.add_asset){
      this.data_app = true;
    }else{
      this.data_valid=true;
    }

    console.log('data assignment all => ', this.data_assignment_all);

  }

  ionViewDidEnter() {
    this.getList();
    // console.log("assign => ",this.assign);
    // console.log("list path => ",this.list_path)
    // console.log("params => ", this.params);
    // console.log("assign classification => ", this.assign_classification);
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }
  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
  showSearch(){
    this.panelSearch=true;
  }
  hideSearch(){
    this.panelSearch=false;
  }

  pilihClassification() {
    let myModal = this.modalCtrl.create(ClassificationPage, { pilih: 1 });
    myModal.onDidDismiss(data => {
      console.log(data.item);
      if(data.item){
        this.selectedClassification=data.item;
        this.params.asset_classification_code=data.item.classification_code;
        this.changeClassification();
      }
    });
    myModal.present();
  }
  pilihCondition() {
    let myModal = this.modalCtrl.create(ConditionPage, { pilih: 1 });
    myModal.onDidDismiss(data => {
      console.log(data.item);
      if(data.item){
        this.selectedCondition=data.item;
        this.params.asset_condition_id=data.item.id;
        this.changeCondition();
      }
    });
    myModal.present();
  }
  pilihLocation() {
    let myModal = this.modalCtrl.create(LocationPage, { pilih: 1 });
    myModal.onDidDismiss(data => {
      if(data.item){
        this.location=data.item;
        this.params.asset_location_id=data.item.id;
        this.getPath(this.location.location_path_id);
        this.changeLocation();
      }
    });
    myModal.present();
  }
  pilihProject() {
    let myModal = this.modalCtrl.create(ProjectPage, { pilih: 1 });
    myModal.onDidDismiss(data => {
      if(data.item){
        this.project_title = data.item.title;
        this.project_code  = data.item.project_code;
        this.changeProject();
      }
    });
    myModal.present();
  }

  changeClassification(){
    this.currentPage=1;
    this.getList()
  }
  changeCondition(){
    this.currentPage=1;
    this.getList()
  }
  changeLocation(){
    this.currentPage=1;
    this.getList()
  }
  changeProject(){
    this.currentPage=1;
    this.getList();
  }

  first(){
    this.currentPage=1;
    this.getList()
  }
  last(){
    this.currentPage=this.total_page;
    this.getList()
  }
  next(){
    this.currentPage++;
    this.getList()
  }
  prev(){
    this.currentPage--;
    this.getList()
  }

  getPath(location_path){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { location_path: location_path };
    
    this.masterApi.getLocation(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.list_path = resp.data;
        this.params.asset_location_path_id = resp.data[0].location_path_id;
      }else{
        
      }
      console.log("path list =>", this,this.list_path);
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    this.panelSearch=false;

    let params:any = { 
      page     : this.currentPage,
      pageSize : this.pageSize
    };
    if(this.params.asset_classification_code!=undefined && this.params.asset_classification_code!='' && !this.data_assignment_all){
      params.asset_classification_code=this.params.asset_classification_code;
    }
    if(this.params.asset_condition_id!=undefined && this.params.asset_condition_id!=''){
      params.asset_condition_id=this.params.asset_condition_id;
    }
    if(this.params.asset_location_id!=undefined && this.params.asset_location_id!='' && !this.data_assignment_all && !this.data_tracking_all){
      params.asset_location_path_id=this.params.asset_location_path_id;
    }
    if(this.location.id!=undefined && !this.data_assignment_all && !this.data_tracking_all){
      params.asset_location_path_id=this.location.location_path_id;
    }
    if(this.keyword!=undefined && this.keyword!=''){
      params.keyword=this.keyword;
    }
    if(this.data_erp == true){
      params.data_source = 'erp';
    }
    if(this.data_valid == true){
      params.data_source = 'valid'
    }
    if(this.data_app == true){
      
    }
    if(this.assign==1){
      params.assignment_id = this.assignment_id;
    }
    if(this.project_code!=undefined && this.project_code!='' && !this.data_assignment_all){
      params.project_code = this.project_code;
    }
    if(this.item_tracking!=undefined && this.item_tracking != ''){
      params.item_tracking_type = this.item_tracking;
    }
    let get:any;

    if(this.tracking!=1){
      if(this.assign==1){
        get = this.assignmentApi.getItem(params);
      }else{
        get = this.itemApi.get(params);
      }
    }else{
       get = this.trackingApi.get_item(params);
    }
    get.subscribe((resp:any) => {
      this.List = resp.data;
      this.total_rows = resp.total_rows;
      this.total_page = this.total_rows/this.pageSize;
      this.total_page = Math.ceil(this.total_page);
      loading.dismiss();
      console.log("List get item =>", resp.data);
    }, (err) => {
      loading.dismiss();
    });
  }

  onInput(e){
    this.currentPage = 1;
    this.pageSize = 50;
    this.total_rows = 0;
    this.total_page = 0;
    this.getList();
  }

  onCancel(e){
    this.currentPage = 1;
    this.pageSize = 50;
    this.total_rows = 0;
    this.total_page = 0;
    this.getList();
  }

  viewImage(rec) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.url_image+rec.generated_name,
      detail: rec
    });
    profileModal.present();
  }

  select(id) {
    let params : any = {
      tracking : this.tracking, 
      id       : id
    };
    if(this.data_erp==true){
      this.navCtrl.push(DetailItemERPPage, params);
    }else{
      if(this.assign>0){
        params.assign              = 1,
        params.assignment_id       = this.assignment_id
        params.data_assignment_all = this.data_assignment_all
        if(this.params.asset_location_id!=undefined){
          params.asset_location_id = this.params.asset_location_id;
          params.assign_type = 'location';
          console.log('assign_param => ', params.asset_location_id)
        }
        if(this.project_code!=undefined){
          params.project_code = this.project_code;
          params.assign_type  = 'project';
          console.log('assign_param => ', params.project_code);
        } 

      }
      this.navCtrl.push(DetailItemPage, params);
    }
  }

  edit(id) {
    let params : any ={
      id : id,
      assign : 1,
      assignment_id : this.assignment_id 
    }
    if(this.params.asset_location_id!=undefined){
      params.assign_type = 'location';
    }
    if(this.project_code!=undefined){
      params.assign_type  = 'project';
    }
    this.navCtrl.push(FormItemPage, params);
  }

  detailPIC() {
    this.navCtrl.push(PicPage);
  }

  add() {
    let params:any = {}
    if(this.assign==1){
      params.assign = this.assign,
      params.assignment_id = this.assignment_id
      if(this.params.asset_location_id!=undefined){
        params.assign_location = this.params.asset_location_id;
        params.assign_location_path = this.list_path[0].location_path_id;
        params.assign_type = 'location';
      }
      if(this.project_code!=undefined){
        params.project_code = this.project_code;
        params.project_title= this.project_title;
        params.assign_type  = 'project';
      } 

    }
    this.navCtrl.push(FormItemPage, params);
  }

  scan(){
    this.barcodeScanner.scan().then(barcodeData => {
      if(barcodeData.text!=''){
        //this.track_item(barcodeData.text);
        let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });
        loading.present();
    
        let params = {
          asset_new_code: barcodeData.text
        };
        this.itemApi.get_detail(params).subscribe((resp:any) => {      
          loading.dismiss();
          if(resp.data.length==0){
            this.presentToast('Asset dengan Code '+barcodeData.text+' Tidak ada.');
          }else{
            this.select(resp.data[0].id);
          }
           
        }, (err) => {
          loading.dismiss();
        });
      }
     }).catch(err => {
         console.log('Error', err);
     });
  }

  track_item(code){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {
      code: code,
      location_id: this.location.id,
      act : 'scanned'
    };
    this.trackingApi.post_item(params).subscribe((resp:any) => {      
      loading.dismiss();
      this.getList();
    }, (err) => {
      loading.dismiss();
    });
  }

  finish_track_location(){
    this.navCtrl.push(FinishOpnamePage,{
      location: this.location
    })
  }


  add_review(){
    this.navCtrl.push(FormReviewPage, {
      location_id   :this.location.id,
      location_name :this.location.location_name
    });
  }

  use_data_erp(){
    this.data_erp   = !this.data_erp;
    this.data_app   = false;
    this.data_valid = false;
    this.getList();
    console.log("data from erp = ",this.data_erp);
  }
  use_data_app(){
    this.data_app   = !this.data_app;
    this.data_erp   = false;
    this.data_valid = false
    this.getList();
    console.log("data from app = ",this.data_app);
  }
  use_data_valid(){
    this.data_valid = !this.data_valid;
    this.data_erp   = false;
    this.data_app   = false;
    this.getList();
    console.log("data from validated = ",this.data_valid);
  }
  use_data_assignment_all(){
    this.data_assignment_all = !this.data_assignment_all;
    this.getList();
    console.log("data from assignment all = ",this.data_assignment_all);
  }
  use_data_tracking_all(){
    this.data_tracking_all = !this.data_tracking_all;
    this.getList();
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/item/page.ts